import AnalyticsCounter from '../../../components/Analytics/AnalyticsCounter';
import FlexWrapper from '../../FlexWrapper';
import UserChart from '../Charts/UserChart';
import { useRemote } from '../../../Utils/Utils';
import { useEffect, useContext, useState } from 'react';
import { applyMethod } from '../AnalyticsUtils';
import { format, lastDayOfMonth, startOfMonth, sub, differenceInMonths } from 'date-fns';
import LoadingIcon from '../../../components/LoadingIcon';
import AnalyticsHeader from './AnalyticsHeader';
import { BannerContext } from '../../../InternalApiApp';


const UsageMetrics = ({ timeFrame, withHeader, dateRanges, passedMetrics, webpage, url, alternativeName, alternativeDateRangers }) => {
	const remote = useRemote();
	const [chartDates, setChartDates] = useState([]);
	const [data, setData] = useState([]);
	const [independentTimeFrame, setIndependentTimeFrame] = useState(withHeader ? alternativeDateRangers ? alternativeDateRangers[0] : dateRanges[0] : timeFrame);
	const [metrics, setMetrics] = useState(null)
	const [rawData, setRowData] = useState(null)
	const { bannerAdditionalInfo } = useContext(BannerContext)

	useEffect(() => {
		getChartDates(independentTimeFrame)
	}, [])

	useEffect(() => {

		Promise.all(
			chartDates.length === 1 && independentTimeFrame.months && independentTimeFrame.months === 1 ? [
				remote.get(`/analytics/aggregates/${webpage ? "webpage" : "sessions"}?from=${format(startOfMonth(sub(new Date(chartDates[0]), { months: 1 })), 'yyyy-MM-dd')}&to=${format(lastDayOfMonth(sub(new Date(chartDates[0]), { months: 1 })), 'yyyy-MM-dd')}${url ? `&url=${url}` : ""}`),
				remote.get(`/analytics/aggregates/${webpage ? "webpage" : "sessions"}?from=${format(startOfMonth(chartDates[0]), 'yyyy-MM-dd')}&to=${format(chartDates[0], 'yyyy-MM-dd')}${url ? `&url=${url}` : ""}`)
			] :
			chartDates.map(workingDate => {
				const start = startOfMonth(workingDate)
				const end = lastDayOfMonth(workingDate)
				return remote.get(`/analytics/aggregates/${webpage ? "webpage" : "sessions"}?from=${format(start, 'yyyy-MM-dd')}&to=${format(end, 'yyyy-MM-dd')}${url ? `&url=${url}` : ""}`);
			})

		).then(results => {
			let flatResults = results.flat();
			const list = [];
			for (var i = 0; i < results.length; i++) {
				if (webpage) {
					list.push({
						name: format(chartDates[i], "MMM yyyy"),
						views: results[i].reduce((a, c) => a + (c.count || 0), 0),
					})
				} else {
					list.push({
						name: chartDates.length === 1 ? i === 0 ? format(sub(new Date(chartDates[0]), { months: 1 }), "dd MMM yyyy") : format(chartDates[0], "dd MMM yyyy") : format(chartDates[i], "MMM yyyy"),
						users: results[i].length
					})
				}
			}
			setData(list);
			setRowData(flatResults)

			//metrics:	
			const myMetrics = {}
			const totals = []

			if (flatResults.length > 0) {
				const promiseMetrics = passedMetrics.map(async (m) => {
						const value = applyMethod(m, flatResults, myMetrics, totals)
						myMetrics[m.label] = value.value
						totals.push(value.total)
				})

				Promise.all(promiseMetrics).then(() => {
					if (Object.keys(myMetrics).length === passedMetrics.length) {
						const metricsArray = Object.keys(myMetrics).map(m => {
							const passedMetricsObj = passedMetrics.reduce((a, c) => ({ ...a, [c.label]: c }), {})
							return <AnalyticsCounter label={m} count={myMetrics[m]} index={passedMetricsObj[m]?.index}  valueStyle={passedMetricsObj[m]?.valueStyle || null} />
						})
						setMetrics(metricsArray.sort((a, b) => {
							return a?.props?.index - b?.props?.index;
						}));
					}
				})
			}
		})
	}, [chartDates, url, bannerAdditionalInfo, webpage, dateRanges, timeFrame, passedMetrics, remote])

	function getChartDates(val) {
		if (typeof val === "string") {
			const endDate = new Date()
			const startDate = new Date(val)
			const monthsDifference = differenceInMonths(endDate, startDate);
			const monthsAgo = Array.from({ length: monthsDifference }, (_, i) => i).reverse()
			setChartDates(monthsAgo.map(v => sub(endDate, { months: v })))
		} else {
			if (val.months && val.months === 1) {
				const date = new Date();
				setChartDates([sub(date, { months: 1 }), date])
			} else {
				const monthsAgo = val && val?.months && val.months > 0 ? Array.from({ length: val.months }, (_, i) => i).reverse() : val?.years ? Array.from({ length: val.years * 12 }, (_, i) => i).reverse() : [5, 4, 3, 2, 1, 0];
				const date = new Date();
				setChartDates(monthsAgo.map(v => sub(date, { months: v })))
			}
		}
		setIndependentTimeFrame(val);
	}


	return (
		<>
			{withHeader && <AnalyticsHeader setTimeFrame={getChartDates} timeFrame={independentTimeFrame} dateRanges={alternativeDateRangers ? alternativeDateRangers : dateRanges}>{alternativeName ? alternativeName : "Usage"}</AnalyticsHeader>}
			{rawData?.length === 0
				? <div>
					<p className='colour-text-neutral-dark-50'>No data to display</p>
					<div style={{ height: 170 }}></div>
				</div>
				: (metrics?.length === 0)
					? <div>
						<LoadingIcon />
						<div style={{ height: 170 }}></div>
					</div>
					: <>
						<FlexWrapper fullWidth gap="xxl" className="mb-l">{metrics}</FlexWrapper>
						<UserChart data={data || []} webpage={webpage} />
					</>}
		</>
	);
}

export default UsageMetrics;